import { useEffect, useRef, useState } from "react";
import { HOME } from "@/constants/testIds";
import { proxied } from "@/lib/api";

const useIsMobile = (breakpoint = 640) => {
  const [isMobile, setIsMobile] = useState(
    typeof window !== "undefined" ? window.innerWidth < breakpoint : false,
  );
  useEffect(() => {
    const on = () => setIsMobile(window.innerWidth < breakpoint);
    window.addEventListener("resize", on);
    return () => window.removeEventListener("resize", on);
  }, [breakpoint]);
  return isMobile;
};

const HeroCarousel = ({ banners = [], speed = 3 }) => {
  const [idx, setIdx] = useState(0);
  const timer = useRef(null);
  const isMobile = useIsMobile();
  const count = banners.length;

  useEffect(() => {
    if (timer.current) clearInterval(timer.current);
    if (speed > 0 && count > 1) {
      timer.current = setInterval(() => setIdx((i) => (i + 1) % count), speed * 1000);
    }
    return () => timer.current && clearInterval(timer.current);
  }, [speed, count]);

  if (!count) {
    return <div className="w-full h-[60vh] bg-[#F3EBE1]" />;
  }

  const click = (link) => link && window.open(link, "_blank", "noopener,noreferrer");

  const bannerSrc = (b) => {
    if (isMobile && b.image_mobile) return b.image_mobile;
    return b.image;
  };

  return (
    <section
      className="relative w-full bg-[#faf6f0]"
      data-testid={HOME.hero}
      data-cursor="banner"
    >
      {/* Mobile: 9:16 portrait aspect (1080x1920). Desktop: 1920:814 landscape */}
      <div className="relative w-full aspect-[9/16] sm:aspect-[1920/814] max-h-[85vh] overflow-hidden">
        {banners.map((b, i) => (
          <div
            key={b.id || i}
            className={`absolute inset-0 transition-opacity duration-[900ms] ${i === idx ? "opacity-100" : "opacity-0 pointer-events-none"}`}
            onClick={() => click(b.link)}
            style={{ cursor: b.link ? "pointer" : "default" }}
          >
            <img
              src={proxied(bannerSrc(b))}
              alt={b.title || "banner"}
              className="w-full h-full object-cover object-center"
              draggable={false}
            />
          </div>
        ))}

        {count > 1 && (
          <div className="absolute bottom-4 md:bottom-6 left-1/2 -translate-x-1/2 z-10 flex items-center gap-2">
            {banners.map((_, i) => (
              <button
                key={i}
                onClick={() => setIdx(i)}
                data-testid={HOME.heroDot(i)}
                data-cursor="button"
                aria-label={`Slide ${i + 1}`}
                className={`h-1.5 rounded-full transition-all ${i === idx ? "w-10 bg-[#8B2323]" : "w-4 bg-[#8B2323]/40"}`}
              />
            ))}
          </div>
        )}
      </div>
    </section>
  );
};

export default HeroCarousel;
